import { Component, EventEmitter, Input, Output } from "@angular/core";
import { buildVersionLabel } from "../../build-version-label";

@Component({
  selector: "app-left-menu-ui-left-menu",
  templateUrl: "./left-menu.component.html",
  styleUrls: ["./left-menu.component.scss"]
})
export class LeftMenuComponent {
  @Input() isOpen!: boolean;
  @Input() withConsole!: boolean;
  @Input() version: null | string = null;

  @Output() logout = new EventEmitter<void>();
  // eslint-disable-next-line @angular-eslint/no-output-native
  @Output() open = new EventEmitter<void>();

  get versionLabel() {
    return buildVersionLabel(this.version);
  }

  onLogout() {
    this.logout.emit();
  }

  onOpen() {
    this.open.emit();
  }
}
